import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.paypal_links,
    props.app.paypal_order,
    (paypal_links, paypal_order) => {
        return {
            paypal_links,
            paypal_order
        }
    }
)